import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ru from './locales/ru.json';
import pt from './locales/pt.json';
import { resolveInitialLocale, getTenantLocaleConfig } from './locales/tenantLocale';

// Локаль и fallback определяются доменом (тенантом), а не хардкодом.
// На clipcutbr.com дефолт PT, fallback EN; на остальных доменах — как было (RU/RU).
const tenant = getTenantLocaleConfig();

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: resolveInitialLocale(),
  fallbackLocale: tenant.fallback,
  messages: {
    en,
    ru,
    pt
  }
});

export default i18n;
